import { Select, MenuItem, SelectChangeEvent } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

function FormListField({
  name,
  label,
  id,
  list,
  value,
  handleChange
}: {
  name: string;
  label: string;
  id: string;
  list: any[];
  value: string;
  handleChange: (event: SelectChangeEvent) => void;
}) {
  return (
    <FormControl fullWidth>
      <InputLabel id={id} sx={{ paddingLeft: "17px", paddingTop: "17px" }}>
        {label}
      </InputLabel>
      <Select
        name={name}
        labelId={id}
        id={id}
        value={value}
        displayEmpty
        onChange={handleChange}
      >
        {list.map((item) => {
          return (
            <MenuItem key={item.code} value={item.code}>
              {item.code}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default FormListField;
